import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class Competence extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'competence'}
            title={'PROCEDURE P5.0 COMPETENCE'}
            exportTitle={'<h2>Procedure P5.0 Competence</h2>'}
            exportFileName={'competence.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (Competence);